import { Accessor, createContext, useContext } from 'solid-js';
import {
  SortableKeyOf,
  SortDirection,
  TreeNodeDefinition,
} from '@trimble/ui-components/solidjs';
import { ProjectDataFilterMode } from '../project-data.types';
import { ProjectDataSelection } from './project-data-panel-selection-factory';

export type SortByKey = SortableKeyOf<Pick<TreeNodeDefinition, 'id' | 'label'>>;

export interface ProjectDataPanelContextValue {
  filterText: Accessor<string>;
  sortBy: Accessor<SortByKey>;
  sortDirection: Accessor<SortDirection>;
  filterMode: Accessor<ProjectDataFilterMode>;
  panelScrollElement?: Accessor<HTMLElement | undefined>;
  /**
   * Provides panel-wide multi-selection support across all trees to facilitate bulk show/hide
   */
  selection?: ProjectDataSelection;
}

const ProjectDataPanelContext = createContext<ProjectDataPanelContextValue>();

export function useProjectDataPanel(): ProjectDataPanelContextValue {
  const ctx = useContext(ProjectDataPanelContext);
  if (!ctx) {
    throw new Error(
      'useProjectDataPanel must be used within a ProjectDataPanel'
    );
  }
  return ctx;
}

export { ProjectDataPanelContext };
